import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TuiDialogContext, TuiTitle } from '@taiga-ui/core';
import { TuiPdfViewer } from '@taiga-ui/layout';
import { POLYMORPHEUS_CONTEXT } from '@taiga-ui/polymorpheus';
import { PdfAttachmentPreviewData } from './pdf-attachment-preview-data';

@Component({
  selector: 'pxc-pdf-attachment-preview',
  imports: [TuiPdfViewer, TuiTitle],
  templateUrl: './pdf-attachment-preview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // The viewer sizes itself against the dialog's flex column: the host must not be a box between them.
  host: { class: 'contents' },
})
export class PdfAttachmentPreviewComponent {
  private readonly context = inject<TuiDialogContext<void, PdfAttachmentPreviewData>>(POLYMORPHEUS_CONTEXT);

  protected readonly title = this.context.data.title;
  protected readonly url = this.context.data.url;
}
